module.exports = __webpack_public_path__ + "static/media/unstakeDarkActive.d3815838.svg";